import { render, staticRenderFns } from "./BuyerVerificationDialog.vue?vue&type=template&id=9012986a&"
import script from "./BuyerVerificationDialog.vue?vue&type=script&lang=js&"
export * from "./BuyerVerificationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports